import React from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    setIsRoomHost, setIsRoomListener, setQuestions, setSendQuestions, setSendDataNotes, setStateDataNotes,
    setActorsResults, setDataNotes, setTasks, setIsTimeStamp, setTimeStamps, setInitialMinutes, setInitialSeconds
} from '../../stories/actions';
import { removeRoom } from '../../services/api';
import * as roomRTC from '../../services/roomRTC';

const ButtonLeave = ({ isUserHost, roomId, setIsRoomHostAction, roomSocketId, setIsRoomListenerAction, setQuestionsAction,
    setSendQuestionsAction, setDataNotesAction, setActorsResultsAction, setSendDataNotesAction, setStateDataNotesAction,
    setTasksAction, setIsTimeStampAction, setTimeStampsAction, setInitialMinutesAction, setInitialSecondsAction }) => {
    const navigateTo = useNavigate();

    const handlerLeaveConnection = async () => {
        setIsRoomHostAction(false);
        setIsRoomListenerAction(false);
        setTasksAction([]);
        setQuestionsAction([]);
        setSendQuestionsAction([]);
        setDataNotesAction([]);
        setActorsResultsAction([]);
        setSendDataNotesAction([]);
        setStateDataNotesAction([]);
        setIsTimeStampAction(false);
        setTimeStampsAction([]);
        setInitialMinutesAction(0);
        setInitialSecondsAction(0);

        if(roomId) {
            roomRTC.removeRoomPeerConnection({ roomSocketId });

            roomRTC.cleanLocalStreamPeerConnection();

            await removeRoom(roomId);
        }

        navigateTo(`/home?session=${isUserHost}`);
    };

    return (
        <div className="btn_leave_circle" onClick={handlerLeaveConnection} title="Encerrar vídeo chamada">
            <span className="material-symbols-outlined icon_leave_leave">stop_circle</span>
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

const mapStateActionToProps = (dispatch) => {
    return {
        setIsRoomHostAction: (isRoomHost) => dispatch(setIsRoomHost(isRoomHost)),
        setIsRoomListenerAction: (isRoomListener) => dispatch(setIsRoomListener(isRoomListener)),
        setTasksAction: (tasks) => dispatch(setTasks(tasks)),
        setQuestionsAction: (questions) => dispatch(setQuestions(questions)),
        setSendQuestionsAction: (sendQuestions) => dispatch(setSendQuestions(sendQuestions)),
        setDataNotesAction: (dataNotes) => dispatch(setDataNotes(dataNotes)),
        setActorsResultsAction: (actorsResults) => dispatch(setActorsResults(actorsResults)),
        setSendDataNotesAction: (sendDataNotes) => dispatch(setSendDataNotes(sendDataNotes)),
        setStateDataNotesAction: (stateDataNotes) => dispatch(setStateDataNotes(stateDataNotes)),
        setTimeStampsAction: (timeStamps) => dispatch(setTimeStamps(timeStamps)),
        setIsTimeStampAction: (isTimeStamp) => dispatch(setIsTimeStamp(isTimeStamp)),
        setInitialMinutesAction: (initialMinutes) => dispatch(setInitialMinutes(initialMinutes)),
        setInitialSecondsAction: (initialSeconds) => dispatch(setInitialSeconds(initialSeconds))
    };
};

export default connect(mapStoreToProps, mapStateActionToProps)(ButtonLeave);